import request from "../../utils/NetWorkUtil";

export async function getModule() {
    return request('/api/Modular', {
        method: 'GET',
        params: {
            page: 1,
            size: 100,
        }
    });
}

export async function getHistory() {
    return request('/api/History', {
        method: 'GET'
    });
}

export async function getPartnerNews() {
    return request('/api/PartnerNews', {
        method: 'GET'
    });
}


export async function submitAlliance(params) {
    return request('/api/Message', {
        method: 'POST',
        data: params
    });
}
